import React from 'react';

import { Button } from 'react-bootstrap';
import { navigate } from 'gatsby';
import { isLoggedIn } from 'services/auth.api';

import { OptimizedImage } from '../common/OptimizedImage';
import DogProfileSection from './DogProfileCard/DogProfileSection';
import FeatureChickenOrLamb from './FeatureChickenOrLamb';

//TODO - This can be broken down to smaller similar components

const FeaturesSection = props => {
  const onGetStarted = () => {
    navigate(isLoggedIn() ? '/account/dashboard/' : '/ingredients/');
  };

  const onShop = () => {
    navigate('/products/');
  };

  const isTester = props.isTester;
  return (
    <div className="features-wrapper">
      <div className="container-fluid">
        <div className="section-item def-w-max no-mgn">
          <div className="row">
            <div className="col-12 col-sm-6">
              <div className="img-wrap-sect ft-section-1">
                {/* <img src={section1} /> */}
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="txt-wrap-sect txt-center-sm">
                <h2 className="mgn-bot-60">
                  Fabulous dry food your dog will thrive on, not just survive.
                </h2>
                <div className="hdr-para-wrapper">
                  <h3>Real food, made fresh in New Zealand</h3>
                  <p className="para-txt">
                    Why buy imported pet food when you can can buy amazing NZ
                    made dog food, with fabulous local ingredients? We make our
                    super healthy dog food in NZ, using all natural ingredients
                    and deliver it straight to you. Its fresher and better for
                    your dog.
                  </p>
                </div>
                <div className="hdr-para-wrapper mgn-top-30">
                  <h3>Nutrients your dog will thrive on.</h3>
                  <p className="para-txt">
                    We design food for your dog to thrive. Our grain free dog
                    food exceeds all AAFCO (global standard) specifications.
                    Most store bought foods simply ‘meet’ the standards for dogs
                    to survive on... but your dog deserves the best dog food NZ
                    has to offer!
                  </p>
                </div>
                {!isTester && (
                  <Button className={isLoggedIn() ? "btn-def mgn-top-30" : "btn-txt btn-txt-org txt-underline"} onClick={onGetStarted}>
                    {isLoggedIn() ? 'Dashboard' : 'See what goes into our grain free dog food'}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        {!isTester && (
          <>
            <div className="ingr-col-wrapper">
              <div className="container-fluid">
                <DogProfileSection />
              </div>
            </div>
            <div className="teat-bg">
              <div className="section-item def-w-max">
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="txt-wrap-sect pdd-rt-50">
                      <h2 className="mgn-bot-50">
                        A personalised feeding plan for your best friend.
                      </h2>
                      <p className="para-txt mgn-bot-50">
                        If you’re confused by vague feeding guides, you’re not
                        alone. Feed your dog the right amount everytime with
                        their own personalised feeding plan.
                      </p>
                      <div className="tick-list">
                        <ul>
                          <li>
                            Personalised feeding plan based on your dog’s
                            specific age, weight and activity level.
                          </li>
                          <li>
                            Know your dogs exact daily feeding needs and use the
                            cool measuring scoop for perfect portions at meal
                            time.
                          </li>
                          <li>
                            Super flexible subscription gives you total control
                            to pause, change or cancel your deliveries any time
                            you like.
                          </li>
                        </ul>
                      </div>
                      <Button
                        className="btn-def mgn-top-50"
                        onClick={onGetStarted}
                      >
                        {isLoggedIn()
                          ? 'Dashboard'
                          : 'Create personalised feeding plan'}
                      </Button>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <div className="op-img-wrap">
                      <OptimizedImage fileName="section_img_2.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* chickenOrLamb 1284 */}
            <div className="ingr-col-wrapper">
              <div className="container-fluid">
                <FeatureChickenOrLamb />
              </div>
            </div>
            <div className="treats-3-bg">
              <div className="section-item def-w-max">
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="op-img-wrap treats-3-bg">
                      <OptimizedImage fileName="section_img_3.png" />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <div className="txt-wrap-sect pdd-lt-50 txt-center-sm">
                      <h2 className="mgn-bot-50">
                        Tailored delivery schedules, right to your door.
                      </h2>
                      <p className="para-txt">
                        We’ll calculate your dog’s perfect meal plan and deliver
                        it to your door.
                        <br />
                        Your orders will arrive just before you run out, without
                        having to think!
                        <br />
                        Save time, money and the hassle of running out of dog
                        food.
                      </p>
                      <Button
                        className="btn-def mgn-top-50"
                        onClick={onGetStarted}
                      >
                        {isLoggedIn()
                          ? 'Dashboard'
                          : 'Calculate delivery schedule'}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="teat-bg">
              <div className="section-item def-w-max">
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="txt-wrap-sect pdd-rt-50">
                      <h2 className="mgn-bot-50">
                        All your pet essentials, sorted in minutes.
                      </h2>
                      <p className="para-txt mgn-bot-50">
                        Tick a few more things off your to-do list by adding all your pet
                        necessities to your subscription
                      </p>
                      <div className="tick-list">
                        <ul>
                          <li>NZ made & 100% natural treats </li>
                          <li>Freeze dried meal toppers</li>
                          <li>Home-compostable poop bags</li>
                          <li>Flea and Worm treatments</li>
                        </ul>
                      </div>
                      <Button
                        className="btn-def mgn-top-50"
                        onClick={onShop}
                      >Shop essentials now
                      </Button>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <div className="op-img-wrap">
                      <OptimizedImage fileName="section_img_4.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FeaturesSection;
